import { render, staticRenderFns } from "./WorkflowIndicators.vue?vue&type=template&id=38eed930&scoped=true"
import script from "./WorkflowIndicators.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowIndicators.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowIndicators.vue?vue&type=style&index=0&id=38eed930&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eed930",
  null
  
)

export default component.exports